<table *ngIf="jobseeker">
  <tr>
    <th>{{ 'label.CurrentModerationJobseeker' | translate }}</th>
    <th *ngIf="!jobseeker.isCreate">
      {{ 'label.EditedModerationJobseeker' | translate }}
    </th>
  </tr>
  <tr>
    <td class="contact-info">
      <app-jobseeker-contact-info
        [jobseeker]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker
            : jobseeker.originalJobseeker
        "
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="false"
        [jobseekerModerationId]="jobseeker.jobseekerModerationId"
        (rejectFields)="setValue($event)"
      ></app-jobseeker-contact-info>
    </td>
    <td class="contact-info" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-contact-info
        [jobseeker]="jobseeker.editedJobseeker"
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="true"
        [jobseekerModerationId]="jobseeker.jobseekerModerationId"
        (rejectFields)="setValue($event)"
      ></app-jobseeker-contact-info>
    </td>
  </tr>
  <tr>
    <td class="work-experience">
      <app-jobseeker-moderation-work-experience
        [workExperience]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.workExperiences
            : jobseeker.originalJobseeker.workExperiences
        "
        [changes]="jobseeker.changes"
        [totalWorkExperienceInMonths]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.totalWorkExperienceInMonths
            : jobseeker.originalJobseeker.totalWorkExperienceInMonths
        "
        [isCreate]="jobseeker.isCreate"
        [isWorkExperienceFilled]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.isWorkExperienceFilled
            : jobseeker.originalJobseeker.isWorkExperienceFilled
        "
        [isEdited]="false"
      ></app-jobseeker-moderation-work-experience>
    </td>
    <td class="work-experience" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-moderation-work-experience
        [workExperience]="jobseeker.editedJobseeker.workExperiences"
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [totalWorkExperienceInMonths]="
          jobseeker.editedJobseeker.totalWorkExperienceInMonths
        "
        [isEdited]="true"
        [isWorkExperienceFilled]="
          jobseeker.editedJobseeker.isWorkExperienceFilled
        "
        (setDictionary)="setWorkExperienceDictionary($event)"
      ></app-jobseeker-moderation-work-experience>
    </td>
  </tr>
  <tr>
    <td class="education">
      <app-jobseeker-moderation-education
        [educations]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.educations
            : jobseeker.originalJobseeker.educations
        "
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="false"
      >
      </app-jobseeker-moderation-education>
    </td>
    <td class="education" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-moderation-education
        [educations]="jobseeker.editedJobseeker.educations"
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        (setDictionary)="setEducationDictionary($event)"
        [isEdited]="true"
      >
      </app-jobseeker-moderation-education>
    </td>
  </tr>
  <tr>
    <td class="skills">
      <app-jobseeker-moderation-skills
        [hardSkills]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.hardSkills
            : jobseeker.originalJobseeker.hardSkills
        "
        [softSkills]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.softSkills
            : jobseeker.originalJobseeker.softSkills
        "
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="false"
      >
      </app-jobseeker-moderation-skills>
    </td>
    <td class="skills" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-moderation-skills
        [hardSkills]="jobseeker.editedJobseeker.hardSkills"
        [softSkills]="jobseeker.editedJobseeker.softSkills"
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        (setDictionary)="setSkillDictionary($event)"
        [isEdited]="true"
      >
      </app-jobseeker-moderation-skills>
    </td>
  </tr>
  <tr>
    <td class="languages">
      <app-jobseeker-moderation-languages
        [languages]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.languages
            : jobseeker.originalJobseeker.languages
        "
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="false"
      >
      </app-jobseeker-moderation-languages>
    </td>
    <td class="languages" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-moderation-languages
        [languages]="jobseeker.editedJobseeker.languages"
        (setDictionary)="setLanguageDictionary($event)"
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="true"
      >
      </app-jobseeker-moderation-languages>
    </td>
  </tr>
  <tr>
    <td class="documents">
      <app-jobseeker-moderation-attachment
        [documents]="
          jobseeker.isCreate
            ? jobseeker.editedJobseeker.documents
            : jobseeker.originalJobseeker.documents
        "
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="false"
      ></app-jobseeker-moderation-attachment>
    </td>
    <td class="documents" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-moderation-attachment
        [documents]="jobseeker.editedJobseeker.documents"
        (setDictionary)="setAttachmentDictionary($event)"
        [changes]="jobseeker.changes"
        [isCreate]="jobseeker.isCreate"
        [isEdited]="true"
      ></app-jobseeker-moderation-attachment>
    </td>
  </tr>
  <tr>
    <td
      class="buttons"
      [ngClass]="{ 'remove-button-tile': !jobseeker.isCreate }"
    >
      <app-jobseeker-moderation-buttons
        *ngIf="jobseeker.isCreate"
        [contactReset]="contactResetMap"
        [experienceReset]="workExperienceResetMap"
        [languageReset]="languageResetMap"
        [documentReset]="documentResetMap"
        [educationReset]="educationResetMap"
        [skillReset]="skillResetMap"
        [jobseekerId]="jobseeker.originalJobseeker.jobseekerId"
        [providerWebsiteId]="jobseeker.originalJobseeker.providerWebsiteId"
        [jobseekerModerationId]="jobseeker.jobseekerModerationId"
        (updateDataEvent)="getJobseekerData(jobseekerId)"
      ></app-jobseeker-moderation-buttons>
    </td>
    <td class="buttons" *ngIf="!jobseeker.isCreate">
      <app-jobseeker-moderation-buttons
        [contactReset]="contactResetMap"
        [experienceReset]="workExperienceResetMap"
        [languageReset]="languageResetMap"
        [documentReset]="documentResetMap"
        [educationReset]="educationResetMap"
        [skillReset]="skillResetMap"
        [jobseekerId]="jobseeker.editedJobseeker.jobseekerId"
        [providerWebsiteId]="jobseeker.editedJobseeker.providerWebsiteId"
        [jobseekerModerationId]="jobseeker.jobseekerModerationId"
        (updateDataEvent)="getJobseekerData(jobseekerId)"
      ></app-jobseeker-moderation-buttons>
    </td>
  </tr>
</table>
